const FILENAME_REGEX = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

export class DownloadFilenameParser {
  static parse(response: Response, defaultFilename: string) {
    let filename = defaultFilename;
    const header = response.headers.get("content-disposition") || "";
    if (header.includes("attachment")) {
      const matches = FILENAME_REGEX.exec(header) || [];
      if (matches.length > 1 && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }
    return filename;
  }
}

export class FileDownloader {
  constructor(private response: Response, private defaultFilename: string) {}

  async download(anchor: HTMLAnchorElement) {
    const blob = await this.response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    anchor.href = downloadUrl;
    anchor.download = DownloadFilenameParser.parse(this.response, this.defaultFilename);
    anchor.click();
    URL.revokeObjectURL(downloadUrl);
  }
}
